/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Stack, SecurityHelper, Button, Select, SelectOption } from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import { gnoment } from 'shared-ui/gnoment';
import { authModalActions } from 'shared-ui/auth/redux';
import { PERMIT, SEASON } from '../propTypes';
import { ALL_DIVISION_TO_TYPE_MAPPING, ANNUAL_PERMIT_TYPES } from '../utils/utils';

class CapeHatterasSidebar extends React.Component {
    static propTypes = {
        permit: PERMIT.isRequired,
        seasons: PropTypes.arrayOf(SEASON),
        pActions: PropTypes.object.isRequired,
        openLoginModal: PropTypes.func.isRequired,
        account: PropTypes.object,
        router: COMPAT_ROUTER_PROP_TYPES,
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedPermitType: '',
            waitingForUserAccount: false,
        };
    }

    componentDidMount() {
        this.props.pActions.purgePendingReservations();
    }

    componentDidUpdate(prevProps) {
        if (
            SecurityHelper.isLoggedIn() &&
            this.state.waitingForUserAccount &&
            this.props.account &&
            prevProps.account !== this.props.account
        ) {
            this.setState({ waitingForUserAccount: false });
            this.continueClick();
        }
    }

    changePermitTypeSelection = (e) => {
        this.setState({ selectedPermitType: e.target.value });
    };

    continueClick = () => {
        const loggedin = SecurityHelper.isLoggedIn();
        if (!loggedin) {
            this.setState({ waitingForUserAccount: true });
            this.props.openLoginModal();
            return;
        }
        const { selectedPermitType } = this.state;
        if (selectedPermitType) {
            let startDate;
            if (ANNUAL_PERMIT_TYPES.includes(selectedPermitType)) {
                startDate = gnoment().format('YYYY-MM-DD');
            }
            const item = {
                division_id: selectedPermitType,
                permit_type: ALL_DIVISION_TO_TYPE_MAPPING[selectedPermitType],
                permit_id: this.props.permit.id,
                start_date: startDate,
            };

            this.props.pActions.createPendingReservations([item]);
            this.props.router.navigate(
                `/vehiclepermits/${this.props.permit.id}/order/detail`
            );
        }
    };

    render() {
        const { permit, seasons } = this.props;
        const couldContinue = !!this.state.selectedPermitType;
        const divisionList = Object.values(permit.divisions ?? {});
        return (
            <Stack>
                <p>Before you get started, please select the length of your stay.</p>
                {divisionList.length && (
                    <Select
                        id="select-permit-type"
                        label="Permit Type"
                        placeholder="Choose an option"
                        value={this.state.selectedPermitType}
                        isDisabled={!seasons?.length}
                        onChange={this.changePermitTypeSelection}
                    >
                        {divisionList.map((div) => (
                            <SelectOption key={div.name} value={div.id}>
                                {div.name}
                            </SelectOption>
                        ))}
                    </Select>
                )}
                <Button
                    onClick={this.continueClick}
                    className="rec-button-primary-large bottom-3"
                    shouldFitContainer
                    disabled={!couldContinue || !seasons?.length}
                >
                    Get Permits
                </Button>
            </Stack>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openLoginModal: bindActionCreators(authModalActions.openLoginModal, dispatch),
    };
}

export default withCompatRouter(connect(null, mapDispatchToProps)(CapeHatterasSidebar));
